export default "__VITE_ASSET__BM$1j4CQ__"